export const useI18NStore = defineStore('i18n', () => {
  interface Database {
    [key: string]: {
      [key: string]: any;
    };
  }
  const db = ref<Database>({})
  const loadedChunks = ref<string[]>([])

  return { db, loadedChunks }
})
